<template>
	<TemplateBase :is-sales="isSales">
		<div class="w-full pb-[5vh] -pt-[10vw]">
			<div
				class="absolute w-screen overflow-hidden -skew-y-6 h-screen md:h-[90vh] -mt-[12vh] max-h-[160vw] md:max-h-[80vw] lg:max-h-none"
			>
				<div class="skew-y-6 pt-[12vh] flex justify-center">
					<AtomVideo
						v-if="backgroundVideo"
						v-bind="backgroundVideo"
						class="object-cover w-full h-screen md:h-[90vh] max-h-[160vw] md:max-h-[80vw] lg:max-h-none"
						autoplay
						loop
						muted
						preload="auto"
						plays-inline
					/>
					<div
						class="absolute top-0 right-0 bottom-0 left-0 from-brand-900/75 to-brand-900/0 bg-gradient-to-r mix-blend-multiply"
					/>
				</div>
			</div>
			<div
				class="container flex flex-col gap-8 z-10 justify-end items-center h-96 lg:h-[35vh]"
			>
				<div class="flex flex-col gap-4">
					<span
						v-if="pageTitlePrefix"
						class="text-white drop-shadow-lg font-display text-title-size-lg lg:text-title-size-xl font-bold uppercase text-center"
					>
						{{ pageTitlePrefix }}
					</span>
					<h1
						class="text-white drop-shadow-lg font-display text-display-size-sm lg:text-display-size-lg font-bold uppercase text-center"
					>
						{{ pageTitle }}
					</h1>
					<span
						v-if="pageTitleSuffix"
						class="text-white drop-shadow-lg font-display text-title-size-lg lg:text-paragraph-size-xl text-center"
					>
						{{ pageTitleSuffix }}
					</span>
				</div>
				<LazyAtomBreadcrumbs
					v-if="breadcrumbs"
					:breadcrumbs="breadcrumbs"
					class="text-functional-size-sm z-10"
				/>
			</div>
		</div>
		<slot />
	</TemplateBase>
</template>

<script lang="ts" setup>
import type { BreadcrumbsType } from '#base/core/types/BreadcrumbsType';
import type { VideoType } from '#base/core/types/VideoType';

defineProps<{
	backgroundVideo?: VideoType;
	pageTitle: string;
	pageTitlePrefix?: string;
	pageTitleSuffix?: string;
	breadcrumbs?: BreadcrumbsType;
	isSales?: boolean;
}>();
</script>
